"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelFileToJSON = exports.ModelFileFromJSONTyped = exports.ModelFileFromJSON = exports.instanceOfModelFile = exports.ModelFileTypeEnum = exports.attributeTypeMapModelFile = void 0;
var FieldJoined_1 = require("./FieldJoined");
exports.attributeTypeMapModelFile = [
    {
        name: "name",
        type: "string",
    },
    {
        name: "rootSnapshotGuid",
        type: "string",
    },
    {
        name: "type",
        type: "string",
    },
    {
        name: "guid",
        type: "string",
    },
    {
        name: "draftSnapshotGuid",
        type: "string",
    },
    {
        name: "templateGuid",
        type: "string",
    },
    {
        name: "pwRequired",
        type: "boolean",
    },
    {
        name: "fields",
        type: "Array<FieldJoined>",
    },
    {
        name: "externalFileCacheKey",
        type: "string",
    },
    {
        name: "externalServiceType",
        type: "string",
    },
    {
        name: "documentGuid",
        type: "string",
    },
];
/**
 * @export
 */
exports.ModelFileTypeEnum = {
    Upload: "Upload",
    Template: "Template",
    External: "External",
    Signer: "Signer",
};
/**
 * Check if a given object implements the ModelFile interface.
 */
function instanceOfModelFile(value) {
    if (!("name" in value) || value["name"] === undefined)
        return false;
    if (!("rootSnapshotGuid" in value) || value["rootSnapshotGuid"] === undefined)
        return false;
    return true;
}
exports.instanceOfModelFile = instanceOfModelFile;
function ModelFileFromJSON(json) {
    return ModelFileFromJSONTyped(json, false);
}
exports.ModelFileFromJSON = ModelFileFromJSON;
function ModelFileFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        name: json["name"],
        rootSnapshotGuid: json["root_snapshot_guid"],
        type: json["type"] == null ? undefined : json["type"],
        guid: json["guid"] == null ? undefined : json["guid"],
        draftSnapshotGuid: json["draft_snapshot_guid"] == null
            ? undefined
            : json["draft_snapshot_guid"],
        templateGuid: json["template_guid"] == null ? undefined : json["template_guid"],
        pwRequired: json["pw_required"] == null ? undefined : json["pw_required"],
        fields: json["fields"] == null
            ? undefined
            : json["fields"].map(FieldJoined_1.FieldJoinedFromJSON),
        externalFileCacheKey: json["external_file_cache_key"] == null
            ? undefined
            : json["external_file_cache_key"],
        externalServiceType: json["external_service_type"] == null
            ? undefined
            : json["external_service_type"],
        documentGuid: json["document_guid"] == null ? undefined : json["document_guid"],
    };
}
exports.ModelFileFromJSONTyped = ModelFileFromJSONTyped;
function ModelFileToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        name: value["name"],
        root_snapshot_guid: value["rootSnapshotGuid"],
        type: value["type"],
        guid: value["guid"],
        draft_snapshot_guid: value["draftSnapshotGuid"],
        template_guid: value["templateGuid"],
        pw_required: value["pwRequired"],
        fields: value["fields"] == null
            ? undefined
            : value["fields"].map(FieldJoined_1.FieldJoinedToJSON),
        external_file_cache_key: value["externalFileCacheKey"],
        external_service_type: value["externalServiceType"],
        document_guid: value["documentGuid"],
    };
}
exports.ModelFileToJSON = ModelFileToJSON;
